module.exports = __webpack_public_path__ + "static/media/btn-story-carousel-right.c0df827c.svg";